"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWNER_PROJECT_UNCATEGORIZED = void 0;
exports.ownerProjectCategoryLabel = ownerProjectCategoryLabel;
exports.collectProjectCategorySuggestions = collectProjectCategorySuggestions;
exports.groupOwnerProjectsByCategory = groupOwnerProjectsByCategory;
exports.OWNER_PROJECT_UNCATEGORIZED = 'Χωρίς κατηγορία';
function ownerProjectCategoryLabel(category) {
    const trimmed = category === null || category === void 0 ? void 0 : category.trim();
    return trimmed || exports.OWNER_PROJECT_UNCATEGORIZED;
}
function collectProjectCategorySuggestions(projects) {
    var _a;
    const set = new Set();
    for (const p of projects) {
        const c = (_a = p.category) === null || _a === void 0 ? void 0 : _a.trim();
        if (c)
            set.add(c);
    }
    return Array.from(set).sort((a, b) => a.localeCompare(b, 'el'));
}
function groupOwnerProjectsByCategory(projects) {
    const map = new Map();
    for (const project of projects) {
        const label = ownerProjectCategoryLabel(project.category);
        if (!map.has(label))
            map.set(label, []);
        map.get(label).push(project);
    }
    return Array.from(map.entries())
        .sort(([a], [b]) => {
        if (a === exports.OWNER_PROJECT_UNCATEGORIZED)
            return 1;
        if (b === exports.OWNER_PROJECT_UNCATEGORIZED)
            return -1;
        return a.localeCompare(b, 'el');
    })
        .map(([categoryLabel, items]) => ({ categoryLabel, projects: items }));
}
